export default __webpack_public_path__ + "static/media/references__barbermania.aae9108b.jpg";